module.exports = __webpack_public_path__ + "static/img/lv1.c25cfa7a.webp";